import { computed } from 'vue';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useOrganizationStore } from '@/store/useOrganizationStore';

export const useBranding = () => {
  const viewerItemStore = useViewerItemStore();
  const organizationStore = useOrganizationStore();

  const orgIsFree = computed(() => {
    // If item is loaded, use item organization data
    if (viewerItemStore.itemOrganization) {
      return viewerItemStore.itemOrganization.free ?? false;
    }
    // Fallback to organization store
    return organizationStore.free ?? false;
  });

  const orgCustomLogoUrl = computed(() => {
    // If item is loaded, use item organization data
    if (viewerItemStore.itemOrganization) {
      return viewerItemStore.itemOrganization.logo;
    }
    // Fallback to organization store
    return organizationStore.logo;
  });

  const hideBranding = computed(() => {
    // If item is loaded, use item organization data
    if (viewerItemStore.itemOrganization) {
      return viewerItemStore.itemOrganization.hideCloudappBranding;
    }
    // Fallback to organization store
    return organizationStore.hideCloudappBranding ?? false;
  });

  const orgRedirectLogoUrl = computed(() => {
    // If item is loaded, use item organization data
    if (viewerItemStore.itemOrganization) {
      return viewerItemStore.itemOrganization.redirectRootUrl;
    }
    // Fallback to organization store
    return organizationStore.redirectRootUrl;
  });

  return {
    orgIsFree,
    orgCustomLogoUrl,
    hideBranding,
    orgRedirectLogoUrl,
  };
};
